import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";
import axios from "axios";

const initialState = {
  data: null,
  loading: false,
  status: null,
  response: null,
  singleEmployer: null,
  mailUser: null,
  docProofResponse: null,
  bulkResume: null,
  resumeResponse: null, // naya field resume submit ke response ke liye
  error: null,
  resumeLoading: false,
  recommedResume: [],
};

export const getEmployerList = createAsyncThunk(
  "GetEmployerList",
  async (body) => {
    try {
      const response = await instance.get(
        `/remark/employer/fetch-employer-list?page=${body.page}&search=${body.search}&orgType=${body.orgType}&subType=${body.subType}&docType=${body.docType}&startDate=${body.startDate}&endDate=${body.endDate}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
);
//SEND-MULTIPLE-MAIL-
export const sendMultpleMail = createAsyncThunk(
  "sendMultpleMail",
  async (body) => {
    try {
      const response = await instance.post(
        "/remark/email/send-multiple-mail",
        body,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
);

export const getEmployerProfile = createAsyncThunk(
  "getEmployerProfile",
  async (body) => {
    try {
      const response = await instance.get("/remark/employer/fetch-profile", {
        params: {
          id: body?.id,
          cu_page: body?.cu_page,
          j_page: body?.j_page,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
);

export const getBulkResumeList = createAsyncThunk(
  "getBulkResumeList",
  async (body) => {
    try {
      const response = await instance.get(
        `/remark/employer/get-ai-resume?user_id=${body?.id}&page=${body?.cu_page}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
);

// export const getEmployerProfile = createAsyncThunk(
//   "getEmployerProfile",
//   async ({ id, cu_page }) => {
//     try {
//       // Pass query parameters properly
//       const response = await instance.get("/remark/employer/fetch-profile", {
//         params: { id, cu_page },
//       });
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   }
// );

export const updateEmployerProfile = createAsyncThunk(
  "updateEmployerProfile",
  async (body) => {
    try {
      const response = await instance.post(
        `/remark/employer/update-employer?id=${body.id}`,
        body.data,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
);

export const MailSendToEmployer = createAsyncThunk(
  "MailSendToEmployer",
  async (body) => {
    try {
      const response = await instance.post(
        "/remark/email/send-mail-for-temp-candidate",
        body,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
);

export const sendMailToNewCompany = createAsyncThunk(
  "sendMailToNewCompany",
  async (body) => {
    try {
      const response = await instance.post(
        "/remark/email/to-new-company",
        body,
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
);

export const VerifyReqMail = createAsyncThunk("VerifyReqMail", async (body) => {
  try {
    const response = await instance.post(
      "/remark/email/verify-request-employer",
      body,
    );
    return response;
  } catch (error) {
    throw error;
  }
});

//Doc Proof Company====

export const DocProofUpload = createAsyncThunk(
  "DocProofUpload",
  async (body) => {
    try {
      const response = await axios.post(
        "https://secureapi.remarkhr.com/others/upload-kyc",
        body,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
);
export const submitResume = createAsyncThunk(
  "resume/submitResume",
  async (body, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      const recommendationKeys = [
        "employer_id",
        "job_id",
        "company_id",
        "recommended_by",
        "mobile",
        "candidate_name",
        "email",
        "experiance",
        "skills",
        "current_location",
        "current_salary",
        "expected_salary",
        "notice_period",
      ];

      if (body?.file) {
        formData.append("resume_url", body.file);
      }

      recommendationKeys.forEach((key) => {
        if (body?.[key] !== undefined && body?.[key] !== null) {
          formData.append(key, body[key]);
        }
      });

      const res = await instance.post(
        "remark/recommendedcanidateresume/upload-candidate-resume",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      if (res?.data?.success === false || res?.data?.status === "error") {
        return rejectWithValue(
          res?.data?.message || "Submit karne mein masla hua",
        );
      }

      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Something went wrong",
      );
    }
  },
);

export const submitMultipleResumes = createAsyncThunk(
  "resume/submitMultipleResumes",
  async (body, { rejectWithValue }) => {
    try {
      const formData = new FormData();

      (body?.files || []).forEach((file) => {
        formData.append("resume_url[]", file);
      });

      ["employer_id", "job_id", "company_id", "recommended_by"].forEach(
        (key) => {
          if (body?.[key] !== undefined && body?.[key] !== null) {
            formData.append(key, body[key]);
          }
        },
      );

      const res = await instance.post(
        "remark/recommendedcanidateresume/upload-candidate-resume",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      if (res?.data?.success === false || res?.data?.status === "error") {
        return rejectWithValue(
          res?.data?.message || "Failed to upload resumes.",
        );
      }

      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Something went wrong",
      );
    }
  },
);

export const fetchRecommendedResumes = createAsyncThunk(
  "fetchRecommendedResumes",
  async (body, { rejectWithValue }) => {
    try {
      const response = await instance.get(
        "/remark/recommendedcanidateresume/fetch-candidate-resume",
        {
          params: {
            job_id: body.job_id,
            search: body.search || "",
            startDate: body.startDate || "",
            endDate: body.endDate || "",
            page: body.page || 1,
            limit: body.limit || 10,
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || {
          message: "Failed to fetch recommended resumes.",
        },
      );
    }
  },
);

export const deleteRecommendedResume = createAsyncThunk(
  "deleteRecommendedResume",
  async (id, { rejectWithValue }) => {
    try {
      const response = await instance.delete(
        `/remark/recommendedcanidateresume/delete-candidate-resume/${id}`,
      );

      if (response?.data?.status === "error") {
        return rejectWithValue(response.data);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || {
          message: "Failed to delete recommended resume.",
        },
      );
    }
  },
);

export const EmployerSlice = createSlice({
  name: "EmployerSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getEmployerList.pending, (state, action) => {
      state.loading = true;
      state.response = null;
      state.mailUser = null;
    });
    builder.addCase(getEmployerList.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.status = action.payload.status;
    });
    builder.addCase(getEmployerList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(getEmployerProfile.pending, (state, action) => {
      state.loading = true;
      state.response = null;
      state.singleEmployer = null;
      state.mailUser = null;
    });
    builder.addCase(getEmployerProfile.fulfilled, (state, action) => {
      state.loading = false;
      state.status = action.payload.status;
      state.singleEmployer = action.payload;
    });
    builder.addCase(getEmployerProfile.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(updateEmployerProfile.pending, (state, action) => {
      state.loading = true;
      state.response = null;
    });
    builder.addCase(updateEmployerProfile.fulfilled, (state, action) => {
      state.loading = false;
      state.status = action.payload.status;
      state.response = action.payload;
    });
    builder.addCase(updateEmployerProfile.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(MailSendToEmployer.pending, (state, action) => {
      state.loading = true;
      state.response = null;
    });
    builder.addCase(MailSendToEmployer.fulfilled, (state, action) => {
      state.loading = false;
      state.response = action.payload;
    });
    builder.addCase(MailSendToEmployer.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(sendMailToNewCompany.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(sendMailToNewCompany.fulfilled, (state, action) => {
      state.loading = false;
      state.mailUser = action.payload;
    });
    builder.addCase(sendMailToNewCompany.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(VerifyReqMail.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(VerifyReqMail.fulfilled, (state, action) => {
      state.loading = false;
      state.mailUser = action.payload;
    });
    builder.addCase(VerifyReqMail.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(DocProofUpload.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(DocProofUpload.fulfilled, (state, action) => {
      state.loading = false;
      state.docProofResponse = action.payload;
    });
    builder.addCase(DocProofUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(getBulkResumeList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getBulkResumeList.fulfilled, (state, action) => {
      state.loading = false;
      state.bulkResume = action.payload;
    });
    builder.addCase(getBulkResumeList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder
      .addCase(submitResume.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitResume.fulfilled, (state, action) => {
        state.loading = false;
        state.resumeResponse = action.payload;
      })
      .addCase(submitResume.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      .addCase(submitMultipleResumes.pending, (state) => {
        // Don't change global loading
      })
      .addCase(submitMultipleResumes.fulfilled, (state) => {
        // Don't change global loading
      })
      .addCase(submitMultipleResumes.rejected, (state) => {
        // Don't change global loading
      });

    builder.addCase(fetchRecommendedResumes.pending, (state) => {
      state.resumeLoading = true;
    });
    builder.addCase(fetchRecommendedResumes.fulfilled, (state, action) => {
      state.resumeLoading = false;
      state.recommedResume = action.payload;
    });
    builder.addCase(fetchRecommendedResumes.rejected, (state) => {
      state.resumeLoading = false;
    });
  },
});

export default EmployerSlice.reducer;
